import {gql} from "@apollo/client";

/**
 * Everything a chart draws from. Shared with the dashboard chart widgets, which return the same
 * result type from cache, so a widget and the explorer page cannot drift in what they select.
 */
export const FGM_METRICS_EXPLORER_RESULT_FIELDS = gql`
  fragment MetricsExplorerResultFields on MetricsExplorerResult {
    series {
      key
      ref
      kind
      check_id
      data_type
      metric
      label
      unit
      aggregation
      start_date
      end_date
      time_offset_seconds
      dimensions {
        name
        value
      }
      datapoints {
        time
        value
      }
    }
    analysis {
      series_key
      engine_version
      window {
        start
        end
        datapoint_count
        gap_count
      }
      trend {
        slope_per_day
        intercept
        r_squared
        direction
        pct_change_over_window
        slope_stderr
        slope_ci_low
        slope_ci_high
        p_value
        confidence_level
      }
      baseline {
        method
        mean
        stddev
        p25
        p50
        p75
        p95
        sample_count
        iqr
      }
      anomaly {
        current_zscore
        max_zscore
        outlier_count
        outlier_ratio
        last_outlier_at
      }
      seasonality {
        hour_of_day
        day_of_week
        hour_by_weekday
        strength
        peak_hour
        trough_hour
        timezone
      }
      outliers {
        time
        value
      }
    }
    errors {
      ref
      code
      message
    }
    meta {
      granularity
      total_datapoints
      truncated
      query_count
      query_time_ms
      used_aggregate_tables
    }
  }
`;
